import { useEffect } from "react";
import { errorToast } from "../utils/makeToast";
import toast from "react-hot-toast";

interface NetworkInformation extends EventTarget {
  effectiveType?: "slow-2g" | "2g" | "3g" | "4g";
  addEventListener: (type: string, listener: () => void) => void;
  removeEventListener: (type: string, listener: () => void) => void;
}

const getConnection = (): NetworkInformation | undefined => {
  return (
    (navigator as any).connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection
  );
};

export const useDetectSlowInternet = () => {
  const connection = getConnection();

  const checkConnection = () => {
    const isSlow = ["slow-2g", "2g", "3g"].includes(connection.effectiveType!);
    if (isSlow) {
      toast.dismiss()
      errorToast("⚠️ Your internet connection appears to be slow.");
    }
  };
  useEffect(() => {
    if (!connection || !connection.effectiveType) return;

    checkConnection(); // initial check
    connection.addEventListener("change", checkConnection);

    return () => {
      connection.removeEventListener("change", checkConnection);
    };
  }, []);
  return null;
};
